/**
 * Check if the error is a connection error.
 * @param error - The Axios error object.
 * @returns A boolean indicating if the error is a connection error.
 */
export function isConnectionError(error: any): boolean {
  // No response received (network error, timeout, CORS, etc.)
  if (!error.response) {
    return true;
  }

  // Server responded but with network-related status codes
  const networkErrorCodes = [0, 408, 502, 503, 504, 521, 522, 523, 524];
  return networkErrorCodes.includes(error.response.status);
}

/**
 * Get a user-friendly error message based on the Axios error.
 * @param error - The Axios error object.
 * @returns A string describing the error type.
 */
export function getConnectionErrorType(error: any): string {
  if (!error.response) {
    if (error.code === 'ECONNABORTED') {
      return 'Request timeout';
    }
    if (error.code === 'ENOTFOUND' || error.code === 'ECONNREFUSED') {
      return 'Server unreachable';
    }
    if (error.message?.includes('Network Error')) {
      return 'Network error (possibly CORS)';
    }
    return 'Connection failed';
  }

  // Handle specific HTTP status codes
  switch (error.response.status) {
    case 408:
      return 'Request timeout';
    case 502:
      return 'Bad gateway';
    case 503:
      return 'Service unavailable';
    case 504:
      return 'Gateway timeout';
    default:
      return 'Network error';
  }
}
